// @ts-nocheck
import * as React from 'react';
import ReactPaginate from 'react-paginate';
import Icon from 'components/uielements/Icon';
import PaginationWrapper from './Pagination.styles';
import type { PaginationProps } from './Pagination.types';

const Pagination = ({
  activePage,
  count,
  onPageChange,
  isLoading,
  hrefBuilder,
}: PaginationProps): React.ReactElement<any> | null =>
  !isLoading ? (
    <PaginationWrapper>
      <ReactPaginate
        forcePage={activePage - 1}
        initialPage={parseInt(activePage, 10) - 1}
        previousLabel={<Icon icon='icon-arrow_left' />}
        nextLabel={<Icon icon='icon-arrow_right' />}
        breakLabel='...'
        marginPagesDisplayed={1}
        pageCount={count}
        pageRangeDisplayed={3}
        onPageChange={onPageChange}
        activeLinkClassName='active'
        containerClassName='pagination'
        hrefBuilder={hrefBuilder}
      />
    </PaginationWrapper>
  ) : null;

export default Pagination;
